import React,{useEffect} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import { ButtonGroup, Button, IconButton } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import EmailIcon from '@material-ui/icons/EmailOutlined';
import PowerSettingsNew from '@material-ui/icons/PowerSettingsNew';
import {Dialog, DialogTitle, DialogContent, Box, Divider, Container, Typography  } from "@material-ui/core";
import { userLock } from "../../../../store/actions/admin/user";
import { useSelector, useDispatch } from 'react-redux';



let loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
let isuseradmin :any[] = [];
let isusertrialadmin: any[] = [];
let system_flagged = false;
// let departmentId :any = 0;
// let departmentName :any = "";
let enterprise_billing = false;

if (loginUserData) {
	isuseradmin = loginUserData.role_access.filter((val: any) => val.access_name === "admin_users");
	isusertrialadmin = loginUserData.role_access.filter((val: any) => val.access_name === "trial_admin")
	system_flagged = loginUserData.system_flagged;
	enterprise_billing = loginUserData.enterprise_billing;
	// departmentId = loginUserData.department_id;
	// departmentName = loginUserData.department_name;
}



function descendingComparator(a: [], b: [], orderBy: any) {
	if (b[orderBy] < a[orderBy]) {
		return -1;
	}
	if (b[orderBy] > a[orderBy]) {
		return 1;
	}
	return 0;
}

function getComparator(order: string, orderBy: string) {
	return order === 'desc'
		? (a: any, b: any) => descendingComparator(a, b, orderBy)
		: (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

function stableSort(array: any, comparator: any) {
	const stabilizedThis = array.map((el: any, index: any) => [el, index]);
	stabilizedThis.sort((a: any, b: any) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	});
	return stabilizedThis.map((el: any) => el[0]);
}

function EnhancedTableHead(props: any) {

	const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
	const createSortHandler = (property: any) => (event: any) => {
		onRequestSort(event, property);
	};

	return (
		<TableHead className="tablehead">
			<TableRow className="table_heading_row">
				<TableCell padding="checkbox" className={clsx(classes.head, 'table_header_cell_checkbox')}>
					<Checkbox
						indeterminate={numSelected > 0 && numSelected < rowCount}
						checked={rowCount > 0 && numSelected === rowCount}
						onChange={onSelectAllClick}
					/>
				</TableCell>
				{/* {headCells.map((headCell) => ( */}
				<TableCell
					key={"first_name"}
					align='left'
					padding='normal'
					sortDirection={orderBy === "first_name" ? order : false}
					className={clsx(classes.head, 'table_heading_cell width-18 header_first_name')}
				>
					<TableSortLabel
						active={orderBy === "first_name"}
						direction={orderBy === "first_name" ? order : 'asc'}
						onClick={createSortHandler("first_name")}
					>
						FIRST NAME
						{orderBy === "first_name" ? (
							<IconButton className={"sortable_icon"}>
								{/* {order === 'desc' ? 'sorted descending' : 'sorted ascending'} */}
							</IconButton>
						) : null}
					</TableSortLabel>
				</TableCell>
				<TableCell
					key={"last_name"}
					align='left'
					padding='normal'
					sortDirection={orderBy === "last_name" ? order : false}
					className={clsx(classes.head, 'table_heading_cell width-10 header_last_name')}
				>
					<TableSortLabel
						active={orderBy === "last_name"}
						direction={orderBy === "last_name" ? order : 'asc'}
						onClick={createSortHandler("last_name")}
					>
						LAST NAME
						{orderBy === "last_name" ? (
							<IconButton className={"sortable_icon"}>
								{/* {order === 'desc' ? 'sorted descending' : 'sorted ascending'} */}
							</IconButton>
						) : null}
					</TableSortLabel>
				</TableCell>
				<TableCell
					key={"username"}
					align='left'
					padding='normal'
					sortDirection={orderBy === "username" ? order : false}
					className={clsx(classes.head, 'table_heading_cell width-23 heading_email')}
				>
					<TableSortLabel
						active={orderBy === "username"}
						direction={orderBy === "username" ? order : 'asc'}
						onClick={createSortHandler("username")}
						style={{ width: "100%" }}
					>
						EMAIL
						{orderBy === "username" ? (
							<IconButton className={"sortable_icon"}>
								{/* {order === 'desc' ? 'sorted descending' : 'sorted ascending'} */}
							</IconButton>
						) : null}
					</TableSortLabel>
				</TableCell>
				{(system_flagged == true) &&
					<TableCell
						key={"department_alias"}
						align='left'
						padding='normal'
						sortDirection={orderBy === "department_alias" ? order : false}
						className={clsx(classes.head, 'table_heading_cell width-23 heading_team')}
					>
						<TableSortLabel
							active={orderBy === "department_alias"}
							direction={orderBy === "department_alias" ? order : 'asc'}
							onClick={createSortHandler("department_alias")}
							style={{ width: "100%" }}
						>
							TEAM
							{orderBy === "department_alias" ? (
								<IconButton className={"sortable_icon"}>
								</IconButton>
							) : null}
						</TableSortLabel>
					</TableCell>
				}

				<TableCell key={"role_id"} align='left' padding='normal' className={clsx(classes.head, 'table_heading_cell width-10 header_role')}>ROLE</TableCell>
				<TableCell
					key={"experience"}
					align='left'
					padding='normal'
					sortDirection={orderBy === "experience" ? order : false}
					className={clsx(classes.head, 'table_heading_cell width-10 header_experience')}
				>
					<TableSortLabel
						active={orderBy === "experience"}
						direction={orderBy === "experience" ? order : 'asc'}
						onClick={createSortHandler("experience")}
					>
						EXPERIENCES
						{orderBy === "experience" ? (
							<IconButton className={"sortable_icon"}>
								{/* {order === 'desc' ? 'sorted descending' : 'sorted ascending'} */}
							</IconButton>
						) : null}
					</TableSortLabel>
				</TableCell>
				<TableCell
					key={"last_active"}
					align='left'
					padding='normal'
					sortDirection={orderBy === "last_active" ? order : false}
					className={clsx(classes.head, 'table_heading_cell width-25 heading_last_active')}
				>
					<TableSortLabel
						active={orderBy === "last_active"}
						direction={orderBy === "last_active" ? order : 'asc'}
						onClick={createSortHandler("last_active")}
					>
						LAST ACTIVE
						{orderBy === "last_active" ? (
							<IconButton className={"sortable_icon"}>
								{/* {order === 'desc' ? <img className="sort_desc" src={'/assets/icons/sort.svg'} /> : <img className="sort_asc" src={'/assets/icons/sort.svg'} />} */}
							</IconButton>
						) : null}
					</TableSortLabel>
				</TableCell>
				<TableCell key={"id"} align='left' padding='normal' className={clsx(classes.head, 'table_heading_cell width-10 header_action')}>ACTIONS</TableCell>
				{/* ))} */}
			</TableRow>
		</TableHead>
	);
}

EnhancedTableHead.propTypes = {
	classes: PropTypes.object.isRequired,
	numSelected: PropTypes.number.isRequired,
	onRequestSort: PropTypes.func.isRequired,
	onSelectAllClick: PropTypes.func.isRequired,
	order: PropTypes.oneOf(['asc', 'desc']).isRequired,
	orderBy: PropTypes.string.isRequired,
	rowCount: PropTypes.number.isRequired,
	recommendTags:PropTypes.bool
};


const useStyles = makeStyles((theme) => ({
  root: {
    // width: '100%',
  },
  paper: {
    // width: '100%',
    overflow:"auto",
    marginBottom: theme.spacing(2),
    boxShadow:"none",
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  head: {
    backgroundColor: "#fff",
    position: "sticky",
    top: 0,
    zIndex:1,
    // padding:"5px 10px"
  },
  description:{
    font: "normal normal bold 24px/26px Spartan-bold",
    color: "#697683",
    
    opacity: "1",
    margin:"10px 0 30px 0",
    '@media (max-width: 559px)': {
      textAlign:"center",
      margin: "10px 0 10px 0"
    },
  },
  icon: {
    marginRight: -10,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  tagmodalwrap: {
    margin: 'auto',
    maxWidth: 500,
    borderRadius: 14,
  },
  delemaildesc: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    color: '#697683'
  },
  modalBtn: {
    width: 80,
    height: 36,
    fontFamily: 'roboto-regular',
    textTransform: 'none',
    fontSize: 16,
    marginLeft: 14,
  },
}));

export default function EnhancedTable(props: any) {
  
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected]  = React.useState<number[]>([]);
  const [page, setPage] = React.useState(0);
  const [isOpenconfirmDialog, setIsOpenconfirmDialog] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState<any>('');
  const dispatch = useDispatch();
  const apolloClient = useSelector((state: any) => state.apolloClient);
  if(props.clearSelected == true){
    setSelected([]);
  }

  const { billingDetails, users, roles } = useSelector((state: any) => state.adminUser);
  useEffect(() => {
    if(billingDetails && billingDetails.data && users && roles){
      loginUserData.role_name =billingDetails.data.roleData.role_name
      loginUserData.role_id =billingDetails.data.roleData.role_id
      loginUserData.role_alias =billingDetails.data.roleData.role_alias
      loginUserData.role_description =billingDetails.data.roleData.role_description
      loginUserData.role_access =billingDetails.data.role_access
      localStorage.setItem("user_data",JSON.stringify(loginUserData))
      loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
    }
  }, [billingDetails, users, roles]);

  const handleRequestSort = (event:any, property:any) => {
    event.preventDefault()
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const rows = props.rows;
  

  const handleSelectAllClick = (event:any) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n: any) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event:any, id:number) => {
    event.preventDefault();
    
    const selectedIndex = selected.indexOf(id);
    let newSelected: number[] = []

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event:any, newPage:any) => {
    event.preventDefault();
    setPage(newPage);
  };


  const isSelected = (id: number) => selected.indexOf(id) !== -1;

  const rowsPerPage = 10;
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
 

  let admin_roleid ={role_id: "0"};
  let creator_roleid ={role_id: "0"};
  let subscriber_roleid =[{role_id: "0"}]
  if(props.roles && props.roles.length){
    admin_roleid = props.roles.filter((val:any) => val.role_name === "admin")[0];
    creator_roleid = props.roles.filter((val:any) => val.role_name === "creator")[0];
    subscriber_roleid = roles ? roles.filter((val:any) => (val.role_name === "subscriber" || val.role_name === "subscriberclever" || val.role_name === "subscribersmart" || val.role_name === "subscribergenius")) : [{role_id: "0"}];
  }
  const {loading } = useSelector((state: any) => state.adminUser);
  useEffect(() => {
     if(loading){
       closeConfirmDialog()
     }
  }, [loading]);

  const openConfirmDialog = (user:any) => {
    setSelectedRow(user)
    setIsOpenconfirmDialog(true)
  };

  const closeConfirmDialog = () => {
    setIsOpenconfirmDialog(false)
     setSelectedRow('')
  };
  const onActiveDeactiveUser = () => {
    const request = {
      flag_value:!selectedRow.active,
      flag:'active',
      customer_name:loginUserData.customer_name,
      user_id:Number(selectedRow.user_id),
    }

    dispatch(userLock(apolloClient.client, request));
  };


  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        
        <TableContainer className="admin_custom_table">
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            // size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
			  recommendTags={false}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row: any, index: any) => {
                const isItemSelected = isSelected(row.id);
                const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                      className={`table_row ${row.active===false ? "gray_bg" : ""}`}
                    >
                      <TableCell padding="checkbox" className="table_row_cell_checkbox">
                        <Checkbox
                          onClick={(event) => handleClick(event, row.id)}
                          checked={isItemSelected}
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </TableCell>
                      <TableCell className="table_row_cell" component="th" id={labelId} scope="row" >
                        {row.first_name ? row.first_name : "-"}
                      </TableCell>
                      <TableCell className="table_row_cell"  align="left">{row.last_name ? row.last_name : "-"}</TableCell>
                      <TableCell className="table_row_cell"  align="left">{row.username ? row.username : "-"}</TableCell>
                      {(system_flagged == true) &&
                        <TableCell className="table_row_cell"  align="left">{row.department_alias ? row.department_alias : "-"}</TableCell>
                      }
                      <TableCell className="table_row_cell"  align="left">
                        {/* {row.role_id} */}
                        <Select
                          labelId="select-role"
                          id="select-role"
                          value={row.role_id ? row.role_id : null}
                          onChange={(event: any) => props.handleChangeRole(event, row)}
                          disabled = {(row.department_name === row.username) ? true : false }
                        >
                          {
                            
                            (system_flagged === true || enterprise_billing == true) ?
                              props.roles.map((val: any, index: any) => {
                                return (
                                  <MenuItem key={index} value={val.role_id}>{(row.role_id == val.role_id) ? val.role_description:val.role_alias+"-"+val.role_description}</MenuItem>
                                )
                              }) 
                            :
                            
                            (props.roles && props.roles.length > 0 && system_flagged == false) ?
                                props.roles.map((val: any, index: any) => {
                                  return (
                                    (isuseradmin && isuseradmin.length && isuseradmin[0].access_value) ?
                                    (
                                      (val.role_id == admin_roleid.role_id || val.role_id == creator_roleid.role_id || val.department_id == loginUserData.department_id) &&
                                        <MenuItem key={index} value={val.role_id}>{val.role_description}</MenuItem>
                                    )
                                    :  (isusertrialadmin && isusertrialadmin.length && isusertrialadmin[0].access_value) ?
                                    (
                                      (val.role_id == loginUserData.role_id || val.department_id == loginUserData.department_id || subscriber_roleid.filter((v:any) => v.role_id == val.role_id && (val.role_name.includes(loginUserData.role_name)))[0]) &&
                                        <MenuItem key={index} value={val.role_id}>{val.role_description}</MenuItem>
                                    )
                                    :
                                    <></>
                                  )
                                })
                            :
                              <MenuItem value={0}>No any tenant</MenuItem>
                          }
                        </Select>
                      </TableCell>
                      <TableCell className="table_row_cell"  align="left">{row.experience ? row.experience : "-"}</TableCell>
                      <TableCell className="table_row_cell"  align="left">{row.last_active ? row.last_active : "-"}</TableCell>
                      <TableCell className="table_row_cell"  align="left">
                        <ButtonGroup size="small" >
                          <Button
                            type="button"
                            title="Edit User"
                            style={{border:"none",color:"#717E8B",minWidth:'15px',padding:"5px"}}
                            onClick={
                              () => props.editUserDetail(row)
                            }
                          ><i className="icon-pencil" style={{fontSize:"14px"}}></i> </Button>
                          {(loginUserData.username !== row.username && row.system_flagged === false) && 
                            <Button
                              type="button"
                              title="Delete User"
                              style={{border:"none",color:"#717E8B",minWidth:'15px',padding:"5px"}}
                              onClick={
                                () => props.onDeleteAdminuser(row)
                              }
                            >
                              <DeleteIcon style={{color:"#717E8B",fontSize:"16px"}} />                            
                            </Button>
                          }
                
                          {
                            (row.password_create == false && row.auth_type == 0) &&
                            <Button
                            type="button"
                            title="Resend Email"
                            style={{border:"none",color:"#717E8B",minWidth:'15px',padding:"5px"}}
                            onClick={
                              (event: any) => props.resendEmail(event, row)
                            }
                            >
                              <EmailIcon style={{color:"#717E8B",fontSize:"16px"}} />
                            </Button>
                          }
                          {(loginUserData.username !== row.username && row.system_flagged === false) &&  
                            <Button
                            type="button"
                            title={row.active?"Deactivate user":"Activate user"}
                            style={{border:"none",color:"#717E8B",minWidth:'15px',padding:"5px"}}
                            onClick={() => openConfirmDialog(row)}
                            >
                              <PowerSettingsNew style={{color:row.active?"green":"red",fontSize:"16px"}} />
                            </Button>
                          }
                        </ButtonGroup>
                      
                      </TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: "30px" }}>
                  <TableCell colSpan={8} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          style={{paddingRight:"35px"}}
          labelRowsPerPage=''
          rowsPerPageOptions={[]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          // onChangePage={handleChangePage} // deprecated working on local
          onPageChange={handleChangePage} // latest function
          // onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      <Dialog
        fullWidth={true}
        maxWidth={'xs'}
        open={isOpenconfirmDialog?true:false}
        // className={classes.dialog}
        classes={{
          paper: classes.tagmodalwrap
        }}
        onClose={() => {closeConfirmDialog()}}
      >
        <DialogTitle>
        {(selectedRow && selectedRow.active===true)?"Deactivate":"Activate"} {selectedRow.username}
        </DialogTitle>
        <Divider />
        <DialogContent style={{ paddingLeft: 0, paddingRight: 0 }}>
            <Container maxWidth="md">
              <Typography className={classes.delemaildesc}>
                Are you sure you want to {(selectedRow && selectedRow.active===true)?"deactivate":"activate"} {selectedRow.username} ?
              </Typography>
            </Container>
          </DialogContent>
        <Box mt={3} mb={3} mr={2} display='flex' justifyContent='flex-end'>
          <Button variant="contained" size='small' onClick={()=>closeConfirmDialog()} className={classes.modalBtn}>
            NO
          </Button>
          <Button color='primary' size='small' variant="contained"  onClick={()=>onActiveDeactiveUser()}  className={classes.modalBtn}>
            YES
          </Button>
        </Box>
      </Dialog>
    </div>
  );
}
